import { render, staticRenderFns } from "./pletterquestion.vue?vue&type=template&id=01958b74&scoped=true&"
import script from "./pletterquestion.vue?vue&type=script&lang=js&"
export * from "./pletterquestion.vue?vue&type=script&lang=js&"
import style0 from "./pletterquestion.vue?vue&type=style&index=0&id=01958b74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01958b74",
  null
  
)

export default component.exports